import {useState} from "react";
import {useParams} from "react-router-dom";
import {IIncident, IIncidentToSend, IncidentFileToUpdate} from "../../core/interfaces/incident";
import {useSingle} from "../../hooks/useSingle";
import {updateIncident} from "../../api/IncidentApi";
import {getBase64} from "../../core/helpers/fileHelper";
import {transformDatesToLocale, transformDatesToUTC} from "../../core/helpers/incidentHelper";
import {URL_INCIDENT} from "../../api/endpoints/endpoints";
import {usePrompt} from "../../hooks/usePrompt";
import {useAppDispatch} from "../../store/hooks";
import {addToast} from "../../store/slices/uiSlice";
import {toastError} from "../../core/helpers/toastHelper";
import IncidentContainer from "./components/IncidentContainer/IncidentContainer";

const Incident = () => {
    let {cId, incidentId} = useParams();

    const prompt = usePrompt();
    const [isEditMode, setEditMode] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dispatch = useAppDispatch();


    const [incident, loading, reFetch] = useSingle<IIncident>(URL_INCIDENT(cId ?? "", incidentId ?? ""), transformDatesToLocale);

    const onSubmit = async (incident: IIncident, files?: File[]) => {
        setIsSubmitting(true);

        const newFiles: IncidentFileToUpdate[] = await Promise.all((files ?? []).map(async (file) =>
            ({
                base64: await getBase64(file),
                name: file.name,
                type: file.type,

            } as IncidentFileToUpdate)
        ));

        const incidentToUpdate: IIncidentToSend = {
            ...transformDatesToUTC(incident),
            newFiles
        };

        updateIncident(cId, incidentId, incidentToUpdate).then(data => {
            setIsSubmitting(false);
            if (data.status !== 200) {
                dispatch(addToast(toastError('Något gick fel', 'Det gick inte att uppdatera ditt tillbud, var vänligen försök igen om en liten stund.')))
            } else {
                setEditMode(false);
                reFetch()
            }
        })
    }

    const onCancel = () => {
        prompt(() => setEditMode(false));
    }

    if (loading) {
        return <>Loading ....</>;
    }

    if (incident.id === "") {
        return <> Hittade ej</>
    }

    return <IncidentContainer isNewIncident={false}
                              incident={incident}
                              isEditMode={isEditMode}
                              isSubmitting={isSubmitting}
                              onEdit={() => setEditMode(true)}
                              onSubmit={onSubmit}
                              onCancel={onCancel}/>;

}

export default Incident;